//Initializes IndexedDB database.

import Dexie from 'dexie';

export const db = new Dexie('sugarDBVis');

db.version(1).stores({
    projects: '++id, name, content'
});